export type AvatarSize = "sm" | "md" | "lg" | "xl";

export const AVATAR_SIZE_CLASSES: Record<AvatarSize, string> = {
  sm: "h-8 w-8",
  md: "h-12 w-12", 
  lg: "h-16 w-16",
  xl: "h-20 w-20",
}; 